import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/Austin.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol for Software Development in Austin?</h2>
            <p>
              TekRevol's software development expertise in Austin are unmatched
              as we innovate while maintaining the premium experience for
              operating a software. With a well-documented history of success,
              we've consistently delivered top-tier mobile applications, earning
              recognition in the industry.We possess an in-depth understanding
              of the local market in Austin and its unique dynamics, offering
              your application a competitive edge.{" "}
            </p>
            <p>
              We consistently stay ahead of mobile technology trends, leveraging
              the latest tools and frameworks to create innovative and
              future-proof apps. Moreover, We provide budget-friendly solutions
              without compromising quality, making software development
              accessible to businesses of all sizes.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
